var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkAlt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.896 16.607a1.15 1.15 0 010 1.626l-1.084 1.084a5.748 5.748 0 11-8.128-8.13l1.083-1.083a1.15 1.15 0 011.626 1.626l-1.084 1.084a3.449 3.449 0 004.877 4.877l1.084-1.084a1.15 1.15 0 011.626 0zM10.104 7.393a1.15 1.15 0 010-1.626l1.084-1.083a5.748 5.748 0 018.129 8.128l-1.084 1.084a1.15 1.15 0 01-1.626-1.626l1.084-1.084a3.449 3.449 0 10-4.877-4.877L11.73 7.393a1.15 1.15 0 01-1.626 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.584 13.79a1.15 1.15 0 001.626 1.626l5.202-5.203a1.15 1.15 0 00-1.626-1.625L8.585 13.79z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkAlt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link-alt.fd01fa2239169cdab59ecbd534734957.svg";